var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "300px",
    height: "300px",
    viewBox: "-2.4 -2.4 28.80 28.80",
    id: "telescope-2",
    "data-name": "Line Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon line-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(4.32,4.32), scale(0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-2.4, -2.4), scale(0.8999999999999999)",
    d: "M16,28.988754575451217C17.897751636708275,29.26007120216831,19.930443151738814,28.427774446327867,21.381690049361097,27.175194537218758C22.789112615609003,25.960439671594408,23.076165447684048,23.940769355413316,23.821820889317017,22.237694011834822C24.414511680336304,20.88398958457225,24.430369461277305,19.295847821244347,25.34104667678756,18.132032947950556C27.075974778808927,15.91485314500961,31.7580518743445,15.270240555230504,31.464765013529647,12.470268302684762C31.192777570781804,9.873638877762826,26.39259063643855,10.993775145969241,24.414814197440734,9.289409605151175C22.918629308958927,8.000059648129092,23.20029788075992,5.413648519588943,21.73690200325809,4.0872002401958785C20.179107732364297,2.6751875633507725,18.06974583575998,2.0317397630780882,16,1.6620710392793008C13.733964528681351,1.257343837372618,11.250592468655483,0.8325439472675504,9.183340481317671,1.8450606563076555C7.116646795663078,2.857303915479815,6.267842302248008,5.295792985016728,4.861686490329646,7.117491379008516C3.475502371186669,8.913316110675087,0.5669741660994476,10.315184840581807,0.914925825991574,12.556930259091192C1.3269400238514624,15.211410886370203,4.871796815619755,16.073495506734567,6.574303233186187,18.151353778605586C7.487002499454726,19.265275993863664,7.819717856860281,20.69375760087994,8.58264032102549,21.9151469597515C9.42225583321356,23.25931691187384,10.164709379244622,24.641738055744565,11.311628394070029,25.735503954795785C12.705665350677883,27.06493529689183,14.093065317361438,28.716125072488047,16,28.988754575451217",
    fill: "#9a702d",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M14,21l-3-9M8,21l3-9",
    style: {
      fill: "none",
      stroke: "#2ca9bc",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M4.81,4,15.44,6.81A1,1,0,0,1,16.14,8l-1,3.86a1,1,0,0,1-1.23.71L3.26,9.76ZM21,9.34,16.14,8l-1,3.86L20,13.2ZM5.07,3,3,10.73",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.9600000000000002
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.ad366a4244daa0239b30105fcb05bef1.svg";
export { ForwardRef as ReactComponent };